import { InstitutionInCompareQuery } from 'src/generated/graphql';
import { InstitutionInCompare } from '../models/institution-in-compare';
import { ProgramLevelMapper } from './program-level-mapper';

export class InstitutionInCompareMapper {
  static toDto(data: InstitutionInCompareQuery): InstitutionInCompare {
    return {
      ...data.institutionById,
      programLevels: ProgramLevelMapper.transform(data.programLevelsByOpeId as string[]),
      taFundedCurses: !!data.getTAInsights?.length
        ? data.getTAInsights[0]?.data?.taFundedCurses
        : 0,
      taTotalCost: !!data.getTAInsights?.length ? data.getTAInsights[0]?.data?.taTotalCost : 0,
      dodMemorandum: data.getVAInsights?.dodMemorandum,
      principlesOfExcelence: data.getVAInsights?.principlesOfExcelence,
      hasYellowRibbon: data.getVAInsights?.hasYellowRibbon,
      eightKeys: data.getVAInsights?.eightKeys,
      giBillBeneficiaries: data.getGiBill?.giBillBeneficiaries,
      totalPostPaid: data.getGiBill?.totalPostPaid,
      directLoans: data.getDirectLoans || {},
      grants: data.getGrants || {},
      campusBased: data.getCampusBased || {}
    } as InstitutionInCompare;
  }
}
